import { render, staticRenderFns } from "./PharmacySettings.vue?vue&type=template&id=74b4468e&scoped=true"
import script from "./PharmacySettings.vue?vue&type=script&lang=js"
export * from "./PharmacySettings.vue?vue&type=script&lang=js"
import style0 from "./PharmacySettings.vue?vue&type=style&index=0&id=74b4468e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b4468e",
  null
  
)

export default component.exports